import { APICore } from "./apiCore";

const api = new APICore()

function getOficinas(params:any): any{
    const baseUrl = "/oficinas"
    return api.get(baseUrl,params)
}

function getOficina(id:String): any{
    const baseUrl = `/oficinas/${id}`
    return api.get(baseUrl,{})
}

function addOficina(params:any): any{
    const baseUrl = "/oficinas"
    return api.create(baseUrl,params)
}
function updateOficina(params:any): any{
    const baseUrl = "/oficinas"
    return api.update(baseUrl,params)
}
function deleteOficina(params:any):any{
    const baseUrl = "/oficinas"
    return api.delete(baseUrl,params)
}

export {getOficinas,getOficina,addOficina,updateOficina,deleteOficina}